<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'WelcomePage'
});
</script>
<template>
  <ka-container code="home-page">
    <!-- Conteneur -->
    <ka-container code="conteneur">
      <!-- Conteneur 2 -->
      <ka-container code="conteneur-2">
        <ka-text code="boostez-votre-entreprise">
          <h1 v-html="t('homePage.conteneur.conteneur2.boostezVotreEntreprise.value', `Boostez votre entreprise en formant votre équipe`)" />
        </ka-text>
        <ka-text
          code="mettez-en-place-des"
          :options="{ hidden: null }">
          <span v-html="t('homePage.conteneur.conteneur2.mettezEnPlaceDes.value', `Mettez en place des <strong>formations personnalisées</strong> et productives pour vos équipes. Savourez la pédagogie Matchers, on s’occupe de TOUT le reste !`)" />
        </ka-text>
        <!-- Conteneur -->
        <ka-container code="container-1">
          <!-- Conteneur 2 -->
          <ka-container code="container-2">
            <ka-icon
              code="icone"
              value="i-fa-solid:landmark" />
            <ka-text code="de-la-formation-action">
              <span v-html="t('homePage.conteneur.conteneur2.container1.container2.deLaFormationAction.value', `De la formation-action 100% financée.`)" />
            </ka-text>
          </ka-container>
          <!-- Conteneur 2 -->
          <ka-container code="container-3">
            <ka-icon
              code="icon-1"
              value="i-fa-solid:hands-helping" />
            <ka-text code="animee-par-un-expert">
              <span v-html="t('homePage.conteneur.conteneur2.container1.container3.animeeParUnExpert.value', `Animée par un expert qui matche avec votre projet.`)" />
            </ka-text>
          </ka-container>
          <!-- Conteneur 2 -->
          <ka-container
            code="container-4"
            :options="{ hidden: null }">
            <ka-icon
              code="icon-2"
              value="i-fa-solid:thumbs-up" />
            <ka-text code="une-pedagogie-basee">
              <span v-html="t('homePage.conteneur.conteneur2.container1.container4.unePedagogieBasee.value', `Une pédagogie basée sur vos objectifs.`)" />
            </ka-text>
          </ka-container>
          <!-- Conteneur 2 -->
          <ka-container code="container-5">
            <ka-icon
              code="icon-3"
              value="i-fa-solid:folder-open" />
            <ka-text code="sans-aucune-demarche">
              <span v-html="t('homePage.conteneur.conteneur2.container1.container5.sansAucuneDemarche.value', `Sans aucune démarche administrative.`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-button
          code="je-minscris"
          :options="{
            ripple: true,
            href: `/experts`,
            ariaLabel: `je minscris`,
            click: page.jeMinscrisClick
          }"
          :sm="{ click: page.jeMinscrisClickOnSm }"
          :xs="{ click: page.jeMinscrisClickOnXs }">
          <span v-html="t('homePage.conteneur.conteneur2.jeMinscris.value', `Je recherche un expert`)" />
        </ka-button>
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container
        code="conteneur-1"
        :xs="{ hidden: null }">
        <!-- Conteneur 1 -->
        <ka-container code="container-6">
          <!-- Conteneur 1 -->
          <ka-container
            code="container-7"
            :options="{
              ripple: null,
              href: `/Experts`,
              ariaLabel: `conteneur 1`,
              click: page.container7Click
            }">
            <ka-text
              code="trouvez-lexpert-ideal"
              inner>
              <span v-html="t('homePage.conteneur.conteneur1.container6.container7.trouvezLexpertIdeal.value', `Trouvez l'expert idéal !`)" />
            </ka-text>
            <!-- Conteneur 2 -->
            <ka-container code="container-8" />
          </ka-container>
        </ka-container>
        <!-- Conteneur 1 -->
        <ka-container code="container-9">
          <!-- Conteneur 1 -->
          <ka-container
            code="container-10"
            :options="{
              href: { name: `Connexion` },
              click: page.container10Click
            }">
            <ka-text code="partagez-votre-expertise">
              <span v-html="t('homePage.conteneur.conteneur1.container9.container10.partagezVotreExpertise.value', `Partagez votre expertise !<br> `)" />
            </ka-text>
            <!-- Conteneur 2 -->
            <ka-container code="container-11" />
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Conteneur -->
    <ka-container code="container-12">
      <ka-text code="une-formation-sur-mesure">
        <h2 v-html="t('homePage.container12.uneFormationSurMesure.value', `Une <strong>formation sur-mesure</strong> gratuite, trop beau pour être vrai ?`)" />
      </ka-text>
      <!-- Conteneur 1 -->
      <ka-container code="container-13">
        <ka-text code="des-formations-vraiment">
          <span v-html="t('homePage.container12.container13.desFormationsVraiment.value', `Des formations VRAIMENT adaptées, la mise en relation avec LE formateur parfait, une aide pour rechercher le financement de votre formation... et tout ça gratuitement !? Vous avez un doute ?`)" />
        </ka-text>
      </ka-container>
      <!-- Conteneur -->
      <ka-container code="container-14">
        <ka-button
          code="prendre-rendez-vous"
          :options="{
            ripple: true,
            href: `https://meetings.hubspot.com/christophe-pramil`,
            ariaLabel: `prendre rendez vous`,
            click: page.prendreRendezVousClick
          }">
          <span v-html="t('homePage.container12.container14.prendreRendezVous.value', `Prendre rendez-vous!`)" />
        </ka-button>
      </ka-container>
    </ka-container>
    <!-- Container 2 -->
    <ka-container code="container-15">
      <ka-text code="k300-entreprises">
        <span v-html="t('homePage.container15.300Entreprises.value', `<strong>+ 300 entreprises</strong> accompagnées par Matchers`)" />
      </ka-text>
      <!-- Logo -->
      <ka-container code="logo">
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo La Brigade De Véro, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/70ea2cb7-4c60-4197-8e6c-7d564a127a39/" />
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo Cyme, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/d5f6497e-8d76-4065-89d9-612516da851a/CYME_Logo_White-01.svg" />
        <ka-image
          code="image-3"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo Sporydeal, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/8f49ca47-5e46-4088-bdce-2d1ab46aa697/" />
        <ka-image
          code="image-4"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo MyMediks, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/343f48a2-8f6a-4697-abcd-f82b98112807/" />
        <ka-image
          code="image-5"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo Sweeetch, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/32bfb1e7-b6c0-4cb5-bdaf-b6f89a962a3f/" />
        <ka-image
          code="image-6"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo Axeptio, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/107cb83e-f0c8-4f17-885b-2a5a197730f7/" />
        <ka-image
          code="image-7"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo OuiTrust, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/1bd393fb-8163-4bb3-8e93-38e6c505b0b7/" />
        <ka-image
          code="image-8"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Logo YesCapa, l'une des 300 enreprises clientes accompagnée par Matchers dans sa mise en place de formations sur-mesure.`
          }"
          value="https://ucarecdn.com/46ff8829-1964-4643-a3d0-2513132f2855/" />
      </ka-container>
    </ka-container>
    <!-- Conteneur -->
    <ka-container code="container-16">
      <ka-text code="matchers-comment-ca">
        <h2 v-html="t('homePage.container16.matchersCommentCa.value', `Matchers, comment ça marche ? `)" />
      </ka-text>
      <!-- Conteneur -->
      <ka-container code="container-17">
        <!-- Conteneur 1 -->
        <ka-container
          code="container-18"
          :options="{
            href: { name: `hub-entreprise-Fonctionnement` },
            click: page.container18Click
          }">
          <ka-text code="pour-les-entreprises">
            <span v-html="t('homePage.container16.container17.container18.pourLesEntreprises.value', `Pour les entreprises`)" />
          </ka-text>
          <!-- Container 2 -->
          <ka-container code="container-19">
            <!-- Conteneur -->
            <ka-container code="container-20">
              <ka-icon
                code="icon-4"
                value="i-fa-solid:search" />
              <ka-text
                code="exprimez-votre-projet"
                inner>
                <span v-html="t('homePage.container16.container17.container18.container19.container20.exprimezVotreProjet.value', `Exprimez votre projet de formation pour trouver les financements possibles. `)" />
              </ka-text>
              <ka-text
                code="k-1"
                :options="{ hidden: true }"
                :xs="{ hidden: false }">
                <span v-html="t('homePage.container16.container17.container18.container19.container20.k1.value', `Some text here`)" />
                <template #xs>
                  <span v-html="t('homePage.container16.container17.container18.container19.container20.k1.xs.value', `1.`)" />
                </template>
              </ka-text>
            </ka-container>
            <!-- Conteneur -->
            <ka-container code="container-21">
              <ka-icon
                code="icon-5"
                value="i-fa-solid:hands-helping" />
              <ka-text
                code="vous-etes-connecte"
                inner>
                <span v-html="t('homePage.container16.container17.container18.container19.container21.vousEtesConnecte.value', `Vous êtes connecté avec le meilleur expert, qui va créer votre parcours de formation sur-mesure.`)" />
              </ka-text>
              <ka-text
                code="k-2"
                :options="{ hidden: true }"
                :xs="{ hidden: false }">
                <span v-html="t('homePage.container16.container17.container18.container19.container21.k2.value', `Some text here`)" />
                <template #xs>
                  <span v-html="t('homePage.container16.container17.container18.container19.container21.k2.xs.value', `2.`)" />
                </template>
              </ka-text>
            </ka-container>
            <!-- Conteneur -->
            <ka-container code="container-22">
              <ka-icon
                code="icon-6"
                value="i-fa-solid:signal" />
              <ka-text
                code="ne-vous-souciez-pas"
                inner>
                <span v-html="t('homePage.container16.container17.container18.container19.container22.neVousSouciezPas.value', `Ne vous souciez pas des démarches administratives ni du financement de la formation, on s'occupe de tout, sans coût !`)" />
              </ka-text>
              <ka-text
                code="k-3"
                :options="{ hidden: true }"
                :xs="{ hidden: false }">
                <span v-html="t('homePage.container16.container17.container18.container19.container22.k3.value', `Some text here`)" />
                <template #xs>
                  <span v-html="t('homePage.container16.container17.container18.container19.container22.k3.xs.value', `3.`)" />
                </template>
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <!-- Conteneur 1 -->
        <ka-container
          code="container-23"
          :options="{
            href: { name: `hub-expert-Fonctionnement` },
            click: page.container23Click
          }">
          <ka-text code="pour-les-experts">
            <span v-html="t('homePage.container16.container17.container23.pourLesExperts.value', `Pour les experts`)" />
          </ka-text>
          <!-- Container 2 -->
          <ka-container code="container-24">
            <!-- Conteneur -->
            <ka-container code="container-25">
              <ka-icon
                code="icon-7"
                value="i-fa-solid:user-edit" />
              <ka-text
                code="creez-votre-profil"
                inner>
                <span v-html="t('homePage.container16.container17.container23.container24.container25.creezVotreProfil.value', `Créez votre profil et détaillez votre expertise.`)" />
              </ka-text>
              <ka-text
                code="text-1"
                :options="{ hidden: true }"
                :xs="{ hidden: false }">
                <span v-html="t('homePage.container16.container17.container23.container24.container25.text1.value', `Some text here`)" />
                <template #xs>
                  <span v-html="t('homePage.container16.container17.container23.container24.container25.text1.xs.value', `1.<br> `)" />
                </template>
              </ka-text>
            </ka-container>
            <!-- Conteneur -->
            <ka-container code="container-26">
              <ka-icon
                code="icon-8"
                value="i-fa-solid:hands-helping" />
              <ka-text
                code="un-match-apparait-sur"
                inner>
                <span v-html="t('homePage.container16.container17.container23.container24.container26.unMatchApparaitSur.value', `Un match apparaît sur votre tableau de bord ! Notre équipe organise la rencontre et s’occupe de votre onboarding pour la mission.`)" />
              </ka-text>
              <ka-text
                code="text-2"
                :options="{ hidden: true }"
                :xs="{ hidden: false }">
                <span v-html="t('homePage.container16.container17.container23.container24.container26.text2.value', `Some text here`)" />
                <template #xs>
                  <span v-html="t('homePage.container16.container17.container23.container24.container26.text2.xs.value', `2.`)" />
                </template>
              </ka-text>
            </ka-container>
            <!-- Conteneur -->
            <ka-container code="container-27">
              <ka-icon
                code="icon-9"
                value="i-fa-solid:calendar-check" />
              <ka-text
                code="fixez-vous-meme-le"
                inner>
                <span v-html="t('homePage.container16.container17.container23.container24.container27.fixezVousMemeLe.value', `Fixez vous-même le planning du projet avec le client. En toute simplicité. En toute flexibilité.`)" />
              </ka-text>
              <ka-text
                code="text-3"
                :options="{ hidden: true }"
                :xs="{ hidden: false }">
                <span v-html="t('homePage.container16.container17.container23.container24.container27.text3.value', `Some text here`)" />
                <template #xs>
                  <span v-html="t('homePage.container16.container17.container23.container24.container27.text3.xs.value', `3.`)" />
                </template>
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Section Domaines -->
    <ka-container code="section-domaines">
      <ka-text
        code="des-experts-dans-une"
        :options="{ hidden: null }">
        <span v-html="t('homePage.sectionDomaines.desExpertsDansUne.value', `Des experts dans une infinité de domaines`)" />
      </ka-text>
      <!-- Domaines -->
      <ka-container
        code="domaines"
        :data="page.$info.domaines"
        :options="{ hidden: null }">
        <!-- Domaine -->
        <ka-container code="domaine">
          <ka-icon
            code="icon-10"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="texte">
            <ka-text code="referencement">
              <span v-html="t('homePage.sectionDomaines.domaines.domaine.texte.referencement.value', `Référencement `)" />
            </ka-text>
            <ka-text code="k-120-profils-dexperts">
              <span v-html="t('homePage.sectionDomaines.domaines.domaine.texte.k120ProfilsDexperts.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-2"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button2Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.domaine.button2.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-28">
          <ka-icon
            code="icon-11"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-29">
            <ka-text code="text-4">
              <span v-html="t('homePage.sectionDomaines.domaines.container28.container29.text4.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-5">
              <span v-html="t('homePage.sectionDomaines.domaines.container28.container29.text5.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-3"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button3Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container28.button3.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-30">
          <ka-icon
            code="icon-12"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-31">
            <ka-text code="text-6">
              <span v-html="t('homePage.sectionDomaines.domaines.container30.container31.text6.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-7">
              <span v-html="t('homePage.sectionDomaines.domaines.container30.container31.text7.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-4"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button4Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container30.button4.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-32">
          <ka-icon
            code="icon-13"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-33">
            <ka-text code="text-8">
              <span v-html="t('homePage.sectionDomaines.domaines.container32.container33.text8.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-9">
              <span v-html="t('homePage.sectionDomaines.domaines.container32.container33.text9.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-5"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button5Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container32.button5.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-34">
          <ka-icon
            code="icon-14"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-35">
            <ka-text code="text-10">
              <span v-html="t('homePage.sectionDomaines.domaines.container34.container35.text10.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-11">
              <span v-html="t('homePage.sectionDomaines.domaines.container34.container35.text11.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-6"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button6Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container34.button6.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-36">
          <ka-icon
            code="icon-15"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-37">
            <ka-text code="text-12">
              <span v-html="t('homePage.sectionDomaines.domaines.container36.container37.text12.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-13">
              <span v-html="t('homePage.sectionDomaines.domaines.container36.container37.text13.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-7"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button7Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container36.button7.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-38">
          <ka-icon
            code="icon-16"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-39">
            <ka-text code="text-14">
              <span v-html="t('homePage.sectionDomaines.domaines.container38.container39.text14.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-15">
              <span v-html="t('homePage.sectionDomaines.domaines.container38.container39.text15.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-8"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button8Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container38.button8.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
        <!-- Domaine -->
        <ka-container code="container-40">
          <ka-icon
            code="icon-17"
            value="i-fa-solid:signal" />
          <!-- Texte -->
          <ka-container code="container-41">
            <ka-text code="text-16">
              <span v-html="t('homePage.sectionDomaines.domaines.container40.container41.text16.value', `Référencement `)" />
            </ka-text>
            <ka-text code="text-17">
              <span v-html="t('homePage.sectionDomaines.domaines.container40.container41.text17.value', `120 profils d'experts`)" />
            </ka-text>
          </ka-container>
          <ka-button
            code="button-9"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.button9Click
            }">
            <span v-html="t('homePage.sectionDomaines.domaines.container40.button9.value', `En savoir + `)" />
          </ka-button>
        </ka-container>
      </ka-container>
    </ka-container>
    <ka-text code="ils-ont-booste-leur">
      <span v-html="t('homePage.ilsOntBoosteLeur.value', `Ils ont boosté leur entreprise grâce à Matchers 👊`)" />
    </ka-text>
    <BlocReassuranceAvisX9
      instance-class="bloc-reassurance-avis-x-9--p3"
      picture-01="https://ucarecdn.com/4c4ae6d6-a75d-4527-8730-c63fcc1a489a/"
      customer-01="Lili | Co-gérante du Domaine d'Arton"
      testimonial-01="Ce que j’ai aimé avec Matchers c’est que ce sont des gens dans la pratique qui vont nous aider à le mettre en œuvre. Les experts savent de quoi ils parlent et on est tout de suite dans quelque chose d'extrêmement utile et concret."
      picture-02="https://ucarecdn.com/95ee8e61-a0ec-4a72-b72c-5927745f44ff/"
      customer-02="Lucas |
Directeur Général & Associé de Charly
"
      testimony-02="Notre accompagnement par Matchers est une vraie réussite, tant sur la formation que sur l'accompagnement pour la partie administrative. Merci !"
      picture-03="https://ucarecdn.com/76002ddc-ac9f-40df-a8f9-6c1d793599ea/"
      customer-03="Laura | Ingénieur technico-commercial chez Baoba"
      testimonial-03="Des formations très qualitatives qui m'ont fait monter en compétences sur de nombreux sujets ! Merci Matchers !"
      picture-04="https://ucarecdn.com/9b1a8b5c-7f83-4f48-af1c-fe3f7f879290/"
      customer-04="L'équipe du pied allez triez"
      testimony-04="Une équipe disponible et compétente, qui a su identifier et répondre à nos besoins. Un accompagnement avec des experts dynamiques et très professionnels. On recommande !"
      picture-05="https://ucarecdn.com/1ad3bfcb-7ebe-4ed6-9d90-b6d2f99bb004/"
      customer-05="Yann | Fondateur & CEO chez SPORTYDEAL"
      testimony-05="En 2 ans, nous avons fait 4 formations dans 4 domaines différents avec des experts Matchers. On adore ! Ils nous trouvent des budgets et des experts, en 2024 on remet ça ! "
      picture-06="https://ucarecdn.com/e39e1e4a-9817-4e82-ba28-df735f110b18/"
      customer-06="Hugo | CEO d'Origame"
      testimony-06="Excellente formation !"
      picture-07="https://ucarecdn.com/0d6f92f6-f9ab-401e-8c5a-aded1d923458/"
      customer-07="Laurent | Managing partner chez Synexser
"
      testimony-07="Au démarrage de notre formation, nous avions développé 20% des interfaces de notre application, en fin de formation nous étions à 80%. L’accompagnement de l’expert nous a permis de rythmer les rendus et éviter les pièges qui nous auraient fait perdre du temps."
      picture-08="https://ucarecdn.com/122146cb-71a5-4c2d-b8b6-34487aeedcef/"
      testimony-08="Ma formation avec Matchers marque un tournant dans mon expérience pro et m'a clairement permis de faire de grands progrès sur le plan managérial, l'acceptation personnelle et d'améliorer mes interactions même dans le contexte perso. J'en sors transformé, plus éveillé et très outillé."
      customer-08="Antoine | Head of Product Design chez Axepio" />
    <CtaVousAvezDesQuestions instance-class="cta-vous-avez-des-questions--p3" />
    <!-- Conteneur 1 -->
    <ka-container code="container-42">
      <!-- Conteneur 2 -->
      <ka-container code="container-43">
        <ka-image
          code="image-9"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `L'équipe Matchers vous accompagne de A à Z dans vos projets de formation ! `
          }"
          value="https://ucarecdn.com/f16aec7a-5df0-4108-9c3f-06067d868e46/" />
      </ka-container>
      <!-- Conteneur 2 -->
      <ka-container code="container-44">
        <!-- Textes -->
        <ka-container code="textes">
          <ka-text code="coucou-cest-nous">
            <span v-html="t('homePage.container42.container44.textes.coucouCestNous.value', `Coucou c’est nous !`)" />
          </ka-text>
          <ka-text code="matchers-cest-une">
            <span v-html="t('homePage.container42.container44.textes.matchersCestUne.value', `Matchers c’est une équipe entièrement à votre disposition pour organiser et optimiser le coaching professionnel de vos équipes sur des expertises-clé.<br><br>Une équipe pour vous conseiller, vous rassurer, vous décharger, vous faire gagner du temps et de l’argent.<br>Bref, soufflez un coup, on s’occupe de tout.`)" />
          </ka-text>
          <ka-button
            code="decouvrir-lequipe"
            :options="{
              ripple: true,
              href: { name: `Equipe` },
              click: page.decouvrirLequipeClick
            }"
            :xs="{ click: page.decouvrirLequipeClickOnXs }">
            <span v-html="t('homePage.container42.container44.textes.decouvrirLequipe.value', `Découvrir l’équipe`)" />
          </ka-button>
        </ka-container>
      </ka-container>
    </ka-container>
    <ka-text code="contactez-nous">
      <span v-html="t('homePage.contactezNous.value', `Contactez nous !`)" />
    </ka-text>
    <!-- Container formulaire -->
    <ka-container code="container-formulaire">
      <ka-iframe
        code="formulaire"
        :options="{
          lazyOptions: {
            throttle: 200,
            once: true,
            intersection: { threshold: 0.1 }
          }
        }"
        value="https://share.hsforms.com/1DsZX-r5RQkuLAn3Zext6jg2xvix"
        inner />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { homePage } from './Index/store'
import BlocReassuranceAvisX9 from '~/components/BlocReassuranceAvisX9/index.vue'
import CtaVousAvezDesQuestions from '~/components/CtaVousAvezDesQuestions/index.vue'
import { appDataStore } from '~/stores'
import './Index/style.scss'
import './Index/style.custom.scss'


provide('$scoped', '--p3')
const appData = appDataStore()
const page = homePage()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
